import ComponentMixin from '../../../../shared/mixins/ComponentMixin';
import PermissionsMixin from '../../mixins/PermissionsMixin';

export default {
    mixins: [
        ComponentMixin,
        PermissionsMixin,
    ],
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        additional: {
            type: Object,
            default: () => {
                return {};
            },
        },
        panelCfg: {
            type: Object,
            default: () => {},
        },
        vScope: {
            type: String,
            default: 'form',
        },
        baseTranslateID: {
            type: String,
        },
        labelDateFormat: {
            type: String,
            default: 'DD/MM/YYYY',
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss',
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            currency: {
                symbol: '€',
                fraction_digits: 2,
                prices_fraction_digits: 2,
            },
        }
    },
    computed: {
        translateID() {
            return `${this.baseTranslateID}`
        },
        modelTranslateID() {
            return `${this.translateID}.model`
        },
        priceDecimalPlaces() {
            return this.currency?.prices_fraction_digits ?? 2;
        },
        stepPriceDecimalPlaces() {
            return this.priceDecimalPlaces != 0 ? 1 / Math.pow(10, this.priceDecimalPlaces) : 1;
        },
    },
    methods: {
        rulesField(field, rules={}) {
            return {required: false, ...rules};
        },
        formatDateToDisplay(val) {
            if(val) {
                let date = moment(val, this.labelDateFormat);
                if(!date.isValid()) {
                    date = moment(val);
                }
                if(date && date.isValid()) {
                    return date.format(this.labelDateFormat);
                }
            }
            return val;
        }
    },
}